/**
 * CSRF helpers for the JWT double-submit cookie pattern used by the backend
 * (Flask-JWT-Extended with JWT_COOKIE_CSRF_PROTECT=True).
 *
 * The backend sets two non-HttpOnly cookies on login:
 *   - csrf_access_token  → echo in X-CSRF-TOKEN on requests authed via access token
 *   - csrf_refresh_token → echo in X-CSRF-TOKEN on requests to /auth/refresh
 *
 * Mirrors `frontend/js/utils.js#getCsrfToken / getRefreshCsrfToken` so the new
 * React app participates in the same protection as the legacy frontend.
 */

function readCookie(name: string): string {
  const match = document.cookie.match(
    new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
  );
  return match ? decodeURIComponent(match[1]) : '';
}

export function getAccessCsrfToken(): string {
  return readCookie('csrf_access_token');
}

export function getRefreshCsrfToken(): string {
  return readCookie('csrf_refresh_token');
}

/** True for HTTP methods that need CSRF on JWT-cookie auth. */
export function isStateChangingMethod(method: string | undefined): boolean {
  const m = (method || 'get').toLowerCase();
  return m === 'post' || m === 'put' || m === 'patch' || m === 'delete';
}
